import { ChangeEventHandler, useState } from "react";
import { Field, type FieldProps } from "formik";

import { ReactComponent as EyeCrossedIcon } from "../../assets/svgs/eye-crossed.svg";
import { ReactComponent as EyeIcon } from "../../assets/svgs/eye.svg";

import styles from "./input.module.css";

interface ComponentProps {
  label: string;
  name: string;
  placeholder?: string;
  displayInput?: string;
  disabled?: boolean;
  bg?: string;
  type?: string;
  value?: string;
  asterisk?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
}

const CustomInput: React.FC<ComponentProps> = (props) => {
  const {
    name,
    label,
    placeholder,
    displayInput,
    disabled,
    bg,
    type,
    value,
    asterisk,
    onChange,
  } = props;
  
  const [showPassword, setShowPassword] = useState(false);

  const inputTypes = ["text", "password", "textArea", "date"];

  const handleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps) => (
        <div className={styles.container}>
          <label>{label} {asterisk && <span className={styles.asterisk}>*</span>}</label>

          {displayInput === inputTypes[0] && (
            <input
              {...field}
              className={styles.input}
              placeholder={placeholder}
              style={{ backgroundColor: bg ? bg : "#fff", width: "100%" }}
              type={type}
              disabled={disabled}
              value={value}
              onChange={onChange}
            />
          )}

          {displayInput === inputTypes[1] && (
            <div className={styles.password}>
              <input
                {...field}
                className={styles.input}
                placeholder={placeholder}
                style={{ backgroundColor: bg ? bg : "#fff", width: "100%" }}
                type={showPassword ? "text" : "password"}
              />

              <button
                type="button"
                className={styles.iconButton}
                onClick={handleShowPassword}
              >
                {showPassword ? (
                  <EyeCrossedIcon width="1.5rem" height="1.5rem" />
                ) : (
                  <EyeIcon width="1.5rem" height="1.5rem" />
                )}
              </button>
            </div>
          )}

          {displayInput === inputTypes[2] && (
            <textarea
              className={styles.input}
              {...field}
              placeholder={placeholder}
              rows={3}
              style={{
                display: "block",
                width: "100%",
                backgroundColor: bg ? bg : "#fff",
              }}
            />
          )}

          {meta.touched && meta.error && (
            <div className={styles.error}>{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
};

export default CustomInput;
